import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { INotificationConfig } from './INotificationConfig'
import { localizedStrings } from '@core/strings'
import { Recipients } from './Recipients'
import { NotificationConfigFormData } from './types'
import { ProjectUser } from '@core/entities/user'
import { NotificationConfigType } from './types'

export class NotificationConfig extends Entity<INotificationConfig> {
  id?: number

  type: NotificationConfigType

  @Type(() => Recipients)
  recipients: Recipients

  allowAdditionalRecipients: boolean

  public static new(payload: unknown): NotificationConfig {
    const entity = plainToInstance(NotificationConfig, payload)

    return entity
  }

  public getRecipientStrings(): string {
    if (!this.recipients) {
      return ''
    }

    const { users, authGroups, emailAddresses } = this.recipients

    const recipientStrings = [
      ...(users && users.length > 0
        ? users.map((user) => user.getFullName())
        : []),
      ...(authGroups && authGroups.length > 0
        ? authGroups.map((group) => group.name)
        : []),
      ...(emailAddresses && emailAddresses.length > 0 ? emailAddresses : []),
    ].join(', ')

    return recipientStrings
  }

  public getTypeString(isInspection = false): string {
    return NotificationConfig.typeString(this.type, isInspection)
  }

  public static typeString(
    type: NotificationConfigType,
    isInspection = false,
  ): string {
    switch (type) {
      case 'CHECKLIST_COMPLETED':
        return isInspection
          ? localizedStrings.inspectionCompleted
          : localizedStrings.checklistCompleted
      default:
        return type
    }
  }

  public getInitialValues(): NotificationConfigFormData {
    return {
      id: this.id,
      type: this.type,
      recipients: {
        userIds: this.recipients?.users?.map((user) => user.id) || [],
        authGroupIds:
          this.recipients?.authGroups?.map((group) => group.id) || [],
        emailAddresses: this.recipients?.emailAddresses || [],
        // we return the users so we can populate the picker without needing to fetch them again
        users: (this.recipients?.users || []) as ProjectUser[],
      },
      allowAdditionalRecipients: this.allowAdditionalRecipients,
    }
  }
}
